import { render, staticRenderFns } from "./RefuseModel.vue?vue&type=template&id=799364b8&scoped=true&"
import script from "./RefuseModel.vue?vue&type=script&lang=js&"
export * from "./RefuseModel.vue?vue&type=script&lang=js&"
import style0 from "./RefuseModel.vue?vue&type=style&index=0&id=799364b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799364b8",
  null
  
)

export default component.exports